"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const _params_1 = require("@params");
const react_apexcharts_1 = __importDefault(require("react-apexcharts"));
const common_1 = require("@components/common");
const PlateChart_1 = require("@app/routes/Dashboard/components/PlateChart");
const chartsCommon_1 = require("@app/routes/Dashboard/chartsCommon");
const locale_1 = __importDefault(require("../locale"));
const CategoryHalfDonutsPopup_1 = __importDefault(require("@app/routes/Dashboard/components/CategoryHalfDonutsPopup"));
const useChartCustomTooltip_1 = require("../hooks/useChartCustomTooltip");
const useTargetExerciseContext_1 = require("@app/routes/Dashboard/hooks/useTargetExerciseContext");
const useChartsDateFilterContext_1 = require("@app/routes/Dashboard/hooks/useChartsDateFilterContext");
const today = (new Date()).toISOString().substr(0, 10);
const labels = [locale_1.default.many_mistakes, locale_1.default.nice_try, locale_1.default.good, locale_1.default.super];
const renderLabelPostfix = (data) => {
    if (!data)
        return '';
    return ` ${data.percent}%`;
};
const renderLabels = dataArr => labels.map((e, i) => e + renderLabelPostfix(dataArr === null || dataArr === void 0 ? void 0 : dataArr[i]));
const PlateDonuts = (0, styled_components_1.default)(PlateChart_1.PlateChart).attrs({
    width: '250px',
    height: '130px',
    className: 'plate-chart'
}) `
  position: relative;
  @media (min-width: 1920px) {
    width: 354px!important;
    height: 190px!important
  }
`;
const donutsPopupInitState = {
    show: false,
    clientX: null,
    clientY: null,
    chartId: undefined,
    dataPointIndex: undefined
};
const CategoryHalfDonuts = () => {
    var _a, _b, _c;
    const [categoriesInfo, setCategoriesInfo] = (0, react_1.useState)({});
    const [articulationDate, setArticulationDate] = (0, react_1.useState)(today);
    const [soundDate, setSoundDate] = (0, react_1.useState)(today);
    const [motorDate, setMotorDate] = (0, react_1.useState)(today);
    const { setTargetExercise } = (0, useTargetExerciseContext_1.useTargetExerciseContext)();
    const { openTooltip, closeTooltip, tooltipState } = (0, useChartCustomTooltip_1.useChartCustomTooltip)({ initState: donutsPopupInitState });
    const { filterState } = (0, useChartsDateFilterContext_1.useChartsDateFilterContext)();
    (0, react_1.useEffect)(() => {
        setArticulationDate(filterState.toDate);
        setSoundDate(filterState.toDate);
        setMotorDate(filterState.toDate);
    }, [filterState.toDate, filterState.fromDate]);
    const fetchCountCategory = ({ group, date }) => {
        const day = date.split('-').reverse().join('.');
        // @ts-ignore
        return fetch(_params_1.apiHost + `/charts/count_categories?group=${group}&date_start=${date}&date_end=${date}&user=${userId}`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": js_cookie_1.default.get("csrftoken")
            }
        }).then(response => response.json());
    };
    (0, react_1.useEffect)(() => {
        fetchCountCategory({ group: 'articulation', date: articulationDate })
            .then(response => setCategoriesInfo(state => (Object.assign(Object.assign({}, state), { articulation: response }))));
    }, [articulationDate]);
    (0, react_1.useEffect)(() => {
        fetchCountCategory({ group: 'sound', date: soundDate })
            .then(response => setCategoriesInfo(state => (Object.assign(Object.assign({}, state), { sound: response }))));
    }, [soundDate]);
    (0, react_1.useEffect)(() => {
        fetchCountCategory({ group: 'motor', date: motorDate })
            .then(response => setCategoriesInfo(state => (Object.assign(Object.assign({}, state), { motor: response }))));
    }, [motorDate]);
    const title = {
        offsetX: 5,
        offsetY: 15,
        style: chartsCommon_1.titleStyle
    };
    const state = {
        options: {
            //labels: ['Mistakes', 'Good', 'Super', 'Nice try'],//categoriesInfo?.labels,
            legend: {
                fontSize: '10px',
                markers: {
                    width: 8,
                    height: 8
                }
            },
            dataLabels: {
                enable: false,
                show: false,
                style: {
                    fontSize: "0px"
                }
            },
            chart: {
                offsetY: 0,
                events: {
                    dataPointSelection: (e, chart, options) => {
                        var _a, _b, _c;
                        console.log(options);
                        const { dataPointIndex, w: { globals: { chartID } } } = options;
                        const { clientX, clientY } = ((_c = (_b = (_a = chart === null || chart === void 0 ? void 0 : chart.series) === null || _a === void 0 ? void 0 : _a.ctx) === null || _b === void 0 ? void 0 : _b.events.w) === null || _c === void 0 ? void 0 : _c.globals) || {};
                        openTooltip({
                            params: {
                                clientX,
                                clientY,
                                chartId: chartID,
                                dataPointIndex
                            }
                        });
                    }
                }
            },
            colors: ['#FF564D', '#FFC54D', '#3BA1AA', '#3CB949'],
            plotOptions: {
                pie: {
                    startAngle: -90,
                    endAngle: 90,
                    offsetY: 70,
                    offsetX: 10,
                    expandOnClick: true,
                    donut: {
                        size: '150px',
                    }
                }
            },
            responsive: [
                {
                    breakpoint: 1920,
                    options: {
                        plotOptions: { pie: { offsetY: 50 } },
                        chart: {
                            width: 260
                        },
                    }
                },
                {
                    breakpoint: 779,
                    options: {
                        chart: {
                            width: 250
                        },
                        legend: {
                            position: 'right'
                        }
                    }
                }
            ],
            tooltip: {
                y: {
                    title: {
                        formatter: () => null
                    },
                    formatter: value => value + '%'
                }
            },
            grid: {
                padding: {
                    top: -10
                }
            }
        }
    };
    // @ts-ignore
    if (!categoriesInfo.sound || !categoriesInfo.motor || !categoriesInfo.articulation)
        return null;
    const stateArticulations = {
        options: Object.assign(Object.assign({}, state.options), { 
            // @ts-ignore
            labels: renderLabels(categoriesInfo === null || categoriesInfo === void 0 ? void 0 : categoriesInfo.articulation), title: Object.assign(Object.assign({}, title), { text: locale_1.default === null || locale_1.default === void 0 ? void 0 : locale_1.default.articulationTitle }), chart: Object.assign(Object.assign({}, state.options.chart), { id: 'articulation' }) }),
        // @ts-ignore
        series: (_a = categoriesInfo === null || categoriesInfo === void 0 ? void 0 : categoriesInfo.articulation) === null || _a === void 0 ? void 0 : _a.map(e => e.percent)
    };
    const stateSound = {
        options: Object.assign(Object.assign({}, state.options), { 
            // @ts-ignore
            labels: renderLabels(categoriesInfo === null || categoriesInfo === void 0 ? void 0 : categoriesInfo.sound), title: Object.assign(Object.assign({}, title), { text: locale_1.default === null || locale_1.default === void 0 ? void 0 : locale_1.default.soundTitle }), chart: Object.assign(Object.assign({}, state.options.chart), { id: 'sound' }) }),
        // @ts-ignore
        series: (_b = categoriesInfo === null || categoriesInfo === void 0 ? void 0 : categoriesInfo.sound) === null || _b === void 0 ? void 0 : _b.map(e => e.percent)
    };
    const stateMotor = {
        options: Object.assign(Object.assign({}, state.options), { 
            // @ts-ignore
            labels: renderLabels(categoriesInfo === null || categoriesInfo === void 0 ? void 0 : categoriesInfo.motor), title: Object.assign(Object.assign({}, title), { text: locale_1.default === null || locale_1.default === void 0 ? void 0 : locale_1.default.motorTitle }), chart: Object.assign(Object.assign({}, state.options.chart), { id: 'motor' }) }),
        // @ts-ignore
        series: (_c = categoriesInfo === null || categoriesInfo === void 0 ? void 0 : categoriesInfo.motor) === null || _c === void 0 ? void 0 : _c.map(e => e.percent)
    };
    // @ts-ignore
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.Flex, { justify: "space-between", className: "donuts-wrapper" },
            react_1.default.createElement(PlateDonuts, null,
                react_1.default.createElement("input", { type: "date", className: "chart-select input-date donut-date", name: "modulesRoundDate", id: "modulesRoundDate", onChange: ev => setArticulationDate(ev.target.value), value: articulationDate, min: filterState.fromDate, max: filterState.toDate }),
                react_1.default.createElement(react_apexcharts_1.default, { options: stateArticulations.options, series: stateArticulations.series, type: "donut" })),
            react_1.default.createElement(PlateDonuts, null,
                react_1.default.createElement("input", { type: "date", className: "chart-select input-date donut-date", name: "modulesRoundDate", id: "modulesRoundDate", onChange: ev => setSoundDate(ev.target.value), value: soundDate, min: filterState.fromDate, max: filterState.toDate }),
                react_1.default.createElement(react_apexcharts_1.default, { options: stateSound.options, series: stateSound.series, type: "donut" })),
            react_1.default.createElement(PlateDonuts, null,
                react_1.default.createElement("input", { type: "date", className: "chart-select input-date donut-date", name: "modulesRoundDate", id: "modulesRoundDate", onChange: ev => setMotorDate(ev.target.value), value: motorDate, min: filterState.fromDate, max: filterState.toDate }),
                react_1.default.createElement(react_apexcharts_1.default, { options: stateMotor.options, series: stateMotor.series, type: "donut" }))),
        tooltipState.show && (react_1.default.createElement(CategoryHalfDonutsPopup_1.default, { ev: tooltipState, data: categoriesInfo[tooltipState.chartId], closePopup: closeTooltip, setTargetExercise: setTargetExercise }))));
};
exports.default = CategoryHalfDonuts;
